import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../../CONSTANTS';
import AllPreApprovalGuarantees from './AllPreApprovalGuarantees';
import AwaitingPaymentPreApprovalGuarantees from './AwaitingPaymentPreApprovalGuarantees';
import PaidPreApprovalGuarantees from './PaidPreApprovalGuarantees';
import ApprovedPreApprovalGuarantees from './ApprovedPreApprovalGuarantees';
import DeclinedPreApprovalGuarantees from './DeclinedPreApprovalGuarantees';

import DashboardWrap from '../../../components/DashboardWrap';

import './guarantees.scss';

const PreApprovalRentGuarantees: FunctionComponent = () => {
  const TabsRaw = [
    {
      id: 1, name: 'All Pre Approval Guarantees', link: AdminRouteName.allPreApprovalGuaranteesRoute, permission: 'can-view-pre-approval-guarantees',
    },
    {
      id: 2, name: 'Awaiting Payment Pre Approval Guarantees', link: AdminRouteName.awaitingPaymentPreApprovalGuaranteesRoute, permission: 'can-view-awaiting-approval-guarantees',
    },
    {
      id: 3, name: 'Paid Pre Approval Guarantees', link: AdminRouteName.paidPreApprovalGuaranteesRoute, permission: 'can-view-paid-guarantees',
    },
    {
      id: 4, name: 'Approved Pre Approval Guarantees', link: AdminRouteName.approvedPreApprovalGuaranteesRoute, permission: 'can-view-all-guarantees-tab',
    },
    {
      id: 5, name: 'Declined Pre Approval Guarantees', link: AdminRouteName.declinedPreApprovalGuaranteesRoute, permission: 'can-view-declined-guarantees',
    },
  ];

  return (
    <DashboardWrap>
      <div className="pre-approval-guarantee-root-cover">
        <Route
          render={(routeProps) => (
            <AllPreApprovalGuarantees
              {...routeProps}
              TabsRaw={TabsRaw}
            />
          )}
          path={AdminRouteName.allPreApprovalGuaranteesRoute}
          exact
        />
        <Route
          render={(routeProps) => (
            <AwaitingPaymentPreApprovalGuarantees
              {...routeProps}
              TabsRaw={TabsRaw}
            />
          )}
          path={AdminRouteName.awaitingPaymentPreApprovalGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <PaidPreApprovalGuarantees
              {...routeProps}
              TabsRaw={TabsRaw}
            />
          )}
          path={AdminRouteName.paidPreApprovalGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <ApprovedPreApprovalGuarantees
              {...routeProps}
              TabsRaw={TabsRaw}
            />
          )}
          path={AdminRouteName.approvedPreApprovalGuaranteesRoute}
        />
        <Route
          render={(routeProps) => (
            <DeclinedPreApprovalGuarantees
              {...routeProps}
              TabsRaw={TabsRaw}
            />
          )}
          path={AdminRouteName.declinedPreApprovalGuaranteesRoute}
        />
      </div>
    </DashboardWrap>
  );
};

export default PreApprovalRentGuarantees;
